<div class="ab-cards">
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">
      {{ newGroups | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="newGroupCountList"
        [dur]="dur"
        [statType]="'new errors'"
      ></ab-trend>
    </h1>
    New errors
  </div>
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">{{ unresolvedGroups | numberToHuman }}</h1>
    Unresolved errors
  </div>
</div>
